import { usePathname } from "next/navigation";

import { Category } from "../services/get-category-data";

export const useCategory = () => {
  const pathname = usePathname();
  const category = pathname.split("/")[4] as Category;

  return { category };
};
